
	<app-message-multi-tabs
		*ngIf="showMultiTabs"
		(onClose)="closeMessage($event)">
	</app-message-multi-tabs>
	<app-side-bar></app-side-bar>
	<router-outlet></router-outlet>
